module.exports = __webpack_public_path__ + "img/logo-Comforest.87cb70e8.svg";